import React from 'react';
import { Car } from 'lucide-react';

export function Footer({ t, setLegalModal }) {
  return (
    <footer className="border-t border-slate-800 mt-12">
      <div className="max-w-7xl mx-auto px-6">
        {/* Row 1: Brand + Tagline */}
        <div className="flex flex-col sm:flex-row items-center justify-between py-3 gap-2">
          <div className="flex items-center gap-2 text-sm">
            <Car className="w-4 h-4 text-emerald-400" />
            <span className="font-semibold text-slate-200">Arbauto</span>
            <span className="px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wider bg-amber-500/20 text-amber-400 border border-amber-500/30 rounded-full">Beta</span>
          </div>
          <div className="text-xs text-slate-500">
            {t('footerTagline')} | <a href="mailto:hello@arbauto.eu" className="text-emerald-400 hover:underline">hello@arbauto.eu</a>
          </div>
        </div>
        {/* Row 2: Copyright + Legal links */}
        <div className="flex flex-col sm:flex-row items-center justify-between py-3 border-t border-slate-800 gap-2">
          <div className="text-xs text-slate-600">
            &copy; 2026 Arbauto. All rights reserved.
          </div>
          <div className="flex items-center gap-3 text-xs">
            <button onClick={() => setLegalModal('privacy')} className="text-slate-500 hover:text-slate-300 transition-colors">{t('privacyPolicy')}</button>
            <span className="text-slate-700">|</span>
            <button onClick={() => setLegalModal('terms')} className="text-slate-500 hover:text-slate-300 transition-colors">{t('termsConditions')}</button>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
